import React, { useCallback, useEffect, useState } from 'react';
import { getKvarxMarketplaceArchive } from '../../../redux/api';
import { JobTrail } from './KvarxMarketplaceView';

const money = (value, currency = 'RSD') => {
  if (value == null || value === '') return '—';
  return `${Number(value).toLocaleString('sr-RS')} ${currency}`;
};

function KvarxLogoTitle() {
  return (
    <h1 className="text-3xl font-extrabold tracking-tight md:text-4xl">
      <span className="text-black">kvar</span>
      <span className="text-[#c8102e]">x</span>
    </h1>
  );
}

export default function KvarxArchiveView() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expandedJobId, setExpandedJobId] = useState('');

  const loadJobs = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getKvarxMarketplaceArchive();
      setJobs(response.data.jobs || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Ugovoreni poslovi nisu učitani.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadJobs();
  }, [loadJobs]);

  return (
    <div className="min-h-full bg-white text-zinc-900">
      <div className="w-full border-b border-zinc-200 bg-white">
        <div className="flex flex-wrap items-end justify-between gap-3 px-4 py-5 sm:px-6">
          <div>
            <KvarxLogoTitle />
            <p className="mt-1 text-sm text-zinc-500">Ugovoreni poslovi — dogovor sa klijentom</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-5 sm:px-6">
        {loading ? <p className="text-sm text-zinc-600">Učitavam...</p> : null}
        {error ? <p className="text-sm text-[#c8102e]">{error}</p> : null}

        {!loading && !error && jobs.length === 0 ? (
          <div className="rounded-xl border border-dashed border-zinc-300 bg-white p-6 text-center text-sm text-zinc-600">
            Nema dogovorenih poslova.
          </div>
        ) : null}

        <div className="space-y-2">
          {jobs.map((job) => {
            const isOpen = expandedJobId === job.id;
            return (
              <div
                key={job.id}
                className={`overflow-hidden rounded-xl border bg-white shadow-sm ${
                  isOpen ? 'border-emerald-300 ring-1 ring-emerald-200' : 'border-zinc-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setExpandedJobId(isOpen ? '' : job.id)}
                  className="flex w-full items-center gap-3 px-3.5 py-3 text-left sm:px-4"
                >
                  <div className="min-w-0 flex-1">
                    <JobTrail job={job} fullAddress />
                  </div>
                  <span className="shrink-0 rounded-md bg-emerald-50 px-2 py-1 text-[11px] font-semibold text-emerald-700">
                    {job.myOffer ? `${job.myOffer.amount} ${job.myOffer.currency || 'RSD'}` : 'Dogovoreno'}
                  </span>
                </button>

                {isOpen ? (
                  <div className="border-t border-zinc-100 bg-zinc-50/60 px-3.5 py-3.5 sm:px-4">
                    <p className="text-xs font-semibold uppercase tracking-wider text-zinc-400">Klijent</p>
                    <p className="mt-1 text-sm text-zinc-800">
                      {[job.name, job.phone, job.email].filter(Boolean).join(' · ')}
                    </p>
                    {job.images?.length ? (
                      <div className="mt-3 flex flex-wrap gap-2">
                        {job.images.map((src) => (
                          <a
                            key={src}
                            href={src}
                            target="_blank"
                            rel="noreferrer"
                            className="block h-16 w-16 overflow-hidden ring-1 ring-zinc-200"
                          >
                            <img src={src} alt="" className="h-full w-full object-cover" />
                          </a>
                        ))}
                      </div>
                    ) : null}
                    {job.myOffer?.message ? (
                      <p className="mt-3 text-sm text-zinc-600">{job.myOffer.message}</p>
                    ) : null}
                    {job.myOffer?.declinedVisitFee != null ? (
                      <p className="mt-2 text-xs text-zinc-500">
                        Dolazak ako klijent odustane: {money(job.myOffer.declinedVisitFee, job.myOffer.currency)}
                      </p>
                    ) : null}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
